import cn from 'classnames';

export interface KeyValueItem {
  key: string;
  value: React.ReactNode;
}

export interface KeyValueStripeTableProps {
  items: KeyValueItem[];
  className?: string;
  activeRowIndex?: number;
}

export const KeyValueStripeTable = ({ items, className, activeRowIndex }: KeyValueStripeTableProps) => (
  <table className={cn('table table-row-bordered mb-0', className)}>
    <tbody>
      {items.map((item, rowIndex) => {
        const isActive = activeRowIndex !== undefined && rowIndex === activeRowIndex;
        const rowClass = cn(rowIndex % 2 === 0 ? 'bg-light' : '', isActive && 'bg-secondary bg-opacity-10');
        return (
          <tr key={rowIndex} className={rowClass}>
            <td className={cn('fw-semibold fs-7 text-gray-500 py-2 px-3', 'w-150px')}>{item.key}</td>
            <td className="fw-semibold fs-7 text-gray-800 py-2 px-3">{item.value}</td>
          </tr>
        );
      })}
    </tbody>
  </table>
);
